export default "__VITE_ASSET__CJvROWLl__"